module.exports = __webpack_public_path__ + "static/media/logo_pl_nl.d3458c2a.svg";